module.exports = __webpack_public_path__ + "static/Date picker-0049806d2c8db9d09a3d9bf7e763b782.svg";